import React, { useEffect } from 'react';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import InvoiceListHead from './InvoiceListHead';
import InvoiceListBody from './InvoiceListBody';

import useStyles from './styles';

export default function InvoicesTable(props) {
  const classes = useStyles();

  const { initialInvoices, wagonDetailsPage, ticketDetailsPage } = props;
  const [invoices, setInvoices] = React.useState(initialInvoices);
  const [order, setOrder] = React.useState('desc');
  const [orderBy, setOrderBy] = React.useState('invoiceDate');

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);

  useEffect(() => {
    setInvoices(initialInvoices);
  }, [initialInvoices]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  function setSelectedInvoices(selectedInvoices) {
    props.setSelectedInvoices(selectedInvoices);
  }
  function selectAll(selected) {
    props.selectAll(selected);
  }
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <Paper className={classes.paper}>
      <TableContainer className={classes.invoiceTbleContainer}>
        <Table
          stickyHeader
          className={classes.table}
          size="medium"
          aria-label="invoice-list"
        >
          <InvoiceListHead
            wagonDetailsPage={wagonDetailsPage}
            ticketDetailsPage={ticketDetailsPage}
            classes={classes}
            order={order}
            orderBy={orderBy}
            selectAll={selectAll}
            onRequestSort={handleRequestSort}
          />
          <InvoiceListBody
            wagonDetailsPage={wagonDetailsPage}
            ticketDetailsPage={ticketDetailsPage}
            page={page}
            rowsPerPage={rowsPerPage}
            order={order}
            orderBy={orderBy}
            rows={invoices}
            setSelectedInvoices={setSelectedInvoices}
          />
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 15, 20, 30, 50]}
        component="div"
        className={classes.paginationBox}
        classes={{
          selectIcon: classes.selectIcon,
          actions: classes.actions,
        }}
        count={invoices.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
